import React from 'react';
import { Box, Container, Typography, Link, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const FOOTER_LINKS = [
  { label: 'Browse Modules', href: '/modules' },
  { label: 'Learning Paths', href: '/learning-paths' },
  { label: 'My Paths', href: '/create-path' },
  { label: 'Profile', href: '/profile' },
];

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#0d1117',
        color: 'rgba(255,255,255,0.55)',
        py: 3,
        mt: 'auto',
        position: 'sticky',
        bottom: 0,
        zIndex: (t) => t.zIndex.appBar - 1,
        borderTop: '1px solid rgba(255,255,255,0.08)',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'center', sm: 'center' }}
          spacing={2}
        >
          <Typography variant="body2" sx={{ fontWeight: 700, color: '#fff', letterSpacing: '-0.3px' }}>
            Learn<Box component="span" sx={{ color: '#0078d4' }}>Finder</Box>
          </Typography>

          <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center">
            {FOOTER_LINKS.map((l) => (
              <Link
                key={l.href}
                component={RouterLink}
                to={l.href}
                underline="none"
                sx={{
                  color: 'rgba(255,255,255,0.5)',
                  fontSize: '0.8rem',
                  '&:hover': { color: '#fff' },
                  transition: 'color 0.15s',
                }}
              >
                {l.label}
              </Link>
            ))}
          </Stack>

          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.35)' }}>
            &copy; {new Date().getFullYear()} Microsoft Learn Catalog
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
